import Api from '@/services/Api'

export default {
  index () {
    return Api().get('permissionRole')
  }
}



// WEBPACK FOOTER //
// ./src/services/PermissionRoleService.js